import React from 'react';
import { Link } from 'react-router-dom';
import Spacing from '../../Spacing';

export default function Banner({ bgUrl, imgUrl, title, subTitle, btnUrl, btnText }) {
  return (
    <div className="container">
      <div
        className="cs_banner cs_style_1 cs_bg_filed"
        style={{ backgroundImage: `url(${bgUrl})` }}
      >
        <img src={imgUrl} alt="Banner" className="cs_banner_img cs_radius_20" />
        <h2 className="cs_banner_title cs_heading_color cs_fs_72">{title}</h2>
        <p className="cs_banner_subtitle cs_description_color cs_fs_20 cs_medium m-0">
          {subTitle}
        </p>
        <Spacing md="50" lg="40" sm="30" />
        <Link to={btnUrl} className="cs_btn cs_style_1">
          <span>{btnText}</span>
          <i>
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
          </i>
        </Link>
      </div>
    </div>
  );
}
